export const EXAM_REVIEW_LIST_REQUEST = "EXAM_REVIEW_LIST_REQUEST";
export const EXAM_REVIEW_LIST_SUCCESS = "EXAM_REVIEW_LIST_SUCCESS";
export const EXAM_REVIEW_LIST_FAIL = "EXAM_REVIEW_LIST_FAIL";